import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from "../../controllers/AccountConnectionLayer";
import "../../style/AppPages.css";
import "../../style/FormStyles.css";
import { useTranslation } from 'react-i18next';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        email: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = await resetPassword(formData.email, t);
        if (data.success) {
            navigate('/confirmation', { state: { message: data.message } });
        }        
    };

    return (
        <div class="page-padding">
            <div class="forgot-password-container">
                <h1 className='title-login'>{t("account.forgotPasswordText")}</h1>
                <form onSubmit={handleSubmit} class="login-section">
                    <div>
                        <label>{t("update.emailLabel")}</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                    </div>
                    <button type="submit" class="form-button">{t("account.resetPasswordLabel")}</button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;